/**
 * SEO for the public sign-up route (`/auth/signup`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export type SignupPageSeoLoaderInput = Record<string, never>

export function signupPageHeadFromLoaderData(_loaderData?: SignupPageSeoLoaderInput | null | undefined) {
  const pageUrl = absoluteUrlForPath('/auth/signup')
  const description =
    'Create your Spicy Friends account for lifestyle groups, events, and venues. Registration collects profile details and age verification when required.'

  return seo({
    title: `Create your member account | ${env.VITE_APP_NAME}`,
    description,
    url: pageUrl,
    image: '/logo-og-image.webp',
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
